import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { VehicleType } from "../model/VehicleType";
import { englishPlural } from "../utils/englishPlural";

export function AddVehicleButton(props: { type: VehicleType; "data-testid": string }) {
  const { type, "data-testid": dataTestId } = props;
  const navigate = useNavigate();
  return (
    <Button
      startIcon={<AddIcon />}
      variant="outlined"
      size="small"
      onClick={() => navigate(`/${englishPlural(type)}/create`)}
      data-testid={dataTestId}
    >
      Hinzufügen
    </Button>
  );
}
